import { render } from "./ProductHistory.vue?vue&type=template&id=cbc3fa78"
import script from "./ProductHistory.vue?vue&type=script&lang=ts"
export * from "./ProductHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script